// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27_iG","toggle":"styles_toggle__1XaYR","preview":"styles_preview__26Dk6"};